import React from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import { getAAFF, getOnlyAAFF } from "../../../services";
import { getAllConsultores, asignarConsultor } from "../../../services";
import { toast } from "react-toastify";
import HeaderBackground from "../../../images/banner_administradores.jpg";
import { Grid } from "@mui/material";
import Add from "../../../icons/add.svg";
import { filterItems } from "../../../functions/funciones";
import BreadCrumb from "../../../components/navbar/Breadcrumb";

class AsignarConsultor extends React.Component {
  constructor() {
    super();
    this.state = {
      nombre: "",
      aaff: undefined,
      resultados: undefined,
      consultores: [],
    };
  }

  componentDidMount() {
    getOnlyAAFF(this.props.params.nif).then((res) => {
      this.setState({ aaff: res });
    });
    getAllConsultores().then((res) => {
      let consultores = [];
      res.forEach((c) => {
        consultores.push({
          id: c.id,
          nif: c.nif,
          nombre: c.nombre,
          apellidos: c.apellidos,
          busqueda: c.nombre + " " + c.apellidos,
        });
        this.setState({ consultores: consultores });
      });
    });
  }

  buscar = (e) => {
    e.preventDefault();
    this.setState({
      resultados: filterItems(this.state.nombre, this.state.consultores),
    });
  };

  render() {
    const { t } = this.props;
    if (this.state.aaff === undefined) return null;
    return (
      <>
        <BreadCrumb
          rutas={[{ path: "/aaff", label: t('aaff:title') }, { path: `/aaff/${this.state.aaff.nif}`, label: this.state.aaff.razonSocial }]}
          style={{ margin: "0 10px" }}
        />
        <div className="pageContent">
          <div className="listPage">
            <div className="gridCard">
                <div className="gridHead">
                    {t('aaff:actions.assignConsultantTitle')}
                </div>
            </div>
          </div>
          <form className="nuevoAAFFForm" onSubmit={this.buscar}>
            <Grid
              container
              spacing={5}
              style={{ marginTop: 20, marginBottom: 20 }}
            >
              <Grid item xs={12} sm={4}>
                <input
                  type="text"
                  placeholder={t('common:form.name')}
                  required
                  value={this.state.nombre}
                  onChange={(e) => this.setState({ nombre: e.target.value })}
                ></input>
              </Grid>
            </Grid>
            <input type="submit" value={t('common:actions.search')}></input>
          </form>
          <Resultados
            resultados={this.state.resultados}
            aaff={this.state.aaff}
            group={this.props.params.idGroup}
            t={t}
          />
        </div>
      </>
    );
  }
}

class Resultados extends React.Component {
  enviarEmail = (e) => {
    console.log("enviar email");
  };

  asignar = (resultado) => {
    const { t } = this.props;
    asignarConsultor(this.props.aaff.id, resultado.id, this.props.group)
      .then((res) => {
        console.log(res)
        toast.success(t('aaff:messages.consultantAssigned'));
        setTimeout(() => {
          window.location.replace("/aaff");
        }, 2000);

      })
      .catch((err) => {
        console.log(err);
        toast.error(t('aaff:messages.assignConsultantError'));
      });
  };
  render() {
    const { t } = this.props;
    if (this.props.resultados === undefined) return null;
    return (
      <div className="tableContainer" style={{ marginTop: 30 }}>
        <table>
          <thead>
            <tr>
              <th>{t('common:consultants.titleSingular')}</th>
              <th>{t('common:form.nif')}</th>
              <th style={{ textAlign: "center" }}>{t('aaff:actions.assign')}</th>
            </tr>
          </thead>
          <tbody>
            {this.props.resultados.map((e, i) => {
              return (
                <tr key={i}>
                  <td>{e.nombre + " " + e.apellidos}</td>
                  <td>{e.nif}</td>
                  <td style={{ textAlign: "center" }}>
                    <div
                      className="asignarButton"
                      style={{
                        marginLeft: "auto",
                        marginRight: "auto",
                        cursor: "pointer",
                      }}
                      onClick={() => this.asignar(e)}
                    >
                      <img src={Add} alt={t('aaff:actions.assign')} />
                      {t('aaff:actions.assign')}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default withTranslation(['aaff', 'common'])(withRouter(AsignarConsultor));
